'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: ', ';\n  background-color: ', ';\n  opacity: ', ';\n  ', ';\n  &:hover {\n    background-color: ', ';\n  }\n'], ['\n  width: ', ';\n  background-color: ', ';\n  opacity: ', ';\n  ', ';\n  &:hover {\n    background-color: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _pclnDesignSystem = require('pcln-design-system');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _PriceArea = require('../PriceArea');

var _PriceArea2 = _interopRequireDefault(_PriceArea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var propTypes = {
  disclaimer: _propTypes2.default.shape({
    disclaimerMessage: _propTypes2.default.string,
    disclaimerMessageTitle: _propTypes2.default.string,
    disclaimerTextSize: _propTypes2.default.number,
    iconName: _propTypes2.default.string,
    isCustomTooltipOpen: _propTypes2.default.bool,
    customTooltip: _propTypes2.default.node
  }),
  bookButtonSize: _propTypes2.default.string,
  priceSize: _propTypes2.default.string,
  strikePriceSize: _propTypes2.default.string,
  price: _propTypes2.default.number,
  strikePrice: _propTypes2.default.number,
  priceColor: _propTypes2.default.string,
  strikePriceColor: _propTypes2.default.string,
  strikeColor: _propTypes2.default.string,
  toFixDecimal: _propTypes2.default.number,
  currencySymbol: _propTypes2.default.string,
  topText: _propTypes2.default.string,
  topTextColor: _propTypes2.default.string,
  priceType: _propTypes2.default.node,
  priceTypeColor: _propTypes2.default.string,
  chooseButtonText: _propTypes2.default.string,
  handleChoose: _propTypes2.default.func,
  feeDisclaimer: _propTypes2.default.string,
  feeDisclaimerColor: _propTypes2.default.string,
  priceIcon: _propTypes2.default.string,
  buttonWidth: _propTypes2.default.string,
  buttonAutoId: _propTypes2.default.string,
  currencyAutoId: _propTypes2.default.string,
  alignItems: _propTypes2.default.string,
  boldStrikePrice: _propTypes2.default.bool,
  buttonColor: _propTypes2.default.string,
  buttonColorHover: _propTypes2.default.string,
  isContentLoading: _propTypes2.default.bool
};

var defaultProps = {
  currencySymbol: '$',
  size: 'large',
  priceColor: 'gray',
  toFixDecimal: 2,
  topTextColor: 'gray',
  priceTypeColor: 'gray',
  chooseButtonText: 'Choose Room',
  feeDisclaimerColor: 'gray',
  bookButtonSize: 'medium',
  buttonWidth: '120px',
  alignItems: 'right',
  buttonColor: 'green',
  buttonColorHover: 'darkGreen',
  isContentLoading: false
};

var ChooseRoomButton = (0, _styledComponents2.default)(_pclnDesignSystem.Button)(_templateObject, function (props) {
  return props.buttonWidth;
}, function (props) {
  return (0, _get2.default)(props.theme.colors, props.buttonColor, 'green');
}, function (_ref) {
  var isContentLoading = _ref.isContentLoading;
  return isContentLoading ? '0' : '1';
}, function (_ref2) {
  var isContentLoading = _ref2.isContentLoading,
      theme = _ref2.theme;
  return !isContentLoading && 'transition: opacity ' + (0, _get2.default)(theme, 'duration.normal', '.2s') + ' ' + (0, _get2.default)(theme, 'timingFunctions.easeIn', 'ease-in');
}, function (props) {
  return (0, _get2.default)(props.theme.colors, props.buttonColorHover, 'darkGreen');
});

var PriceBox = function PriceBox(props) {
  var buttonWidth = props.buttonWidth,
      bookButtonSize = props.bookButtonSize,
      handleChoose = props.handleChoose,
      chooseButtonText = props.chooseButtonText,
      feeDisclaimer = props.feeDisclaimer,
      feeDisclaimerColor = props.feeDisclaimerColor,
      buttonAutoId = props.buttonAutoId,
      alignItems = props.alignItems,
      buttonColor = props.buttonColor,
      buttonColorHover = props.buttonColorHover,
      isContentLoading = props.isContentLoading;


  return _react2.default.createElement(
    _pclnDesignSystem.Box,
    { align: alignItems, textAlign: alignItems },
    _react2.default.createElement(_PriceArea2.default, props),
    handleChoose && _react2.default.createElement(
      ChooseRoomButton,
      {
        buttonWidth: buttonWidth,
        size: bookButtonSize,
        onClick: handleChoose,
        'data-autobot-element-id': buttonAutoId,
        buttonColor: buttonColor,
        buttonColorHover: buttonColorHover,
        isContentLoading: isContentLoading
      },
      _react2.default.createElement(
        _pclnDesignSystem.Text,
        {
          fontWeight: 'bold',
          bold: true,
          fontSize: 1,
          regular: true
        },
        chooseButtonText
      )
    ),
    feeDisclaimer && _react2.default.createElement(
      _pclnDesignSystem.Text,
      {
        fontSize: 0,
        color: feeDisclaimerColor,
        mt: 2
      },
      feeDisclaimer
    )
  );
};

PriceBox.propTypes = propTypes;
PriceBox.defaultProps = defaultProps;

exports.default = PriceBox;